module.exports = __webpack_public_path__ + "static/media/208gt.dd7e21db.jpg";